import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Invoice } from '../../../models/invoice';
import { InvoiceService } from '../../../services/invoice.service';

@Component({
  selector: 'app-dowload-invoice',
  templateUrl: './dowload-invoice.component.html',
  styleUrls: ['./dowload-invoice.component.css']
})
export class DowloadInvoiceComponent implements OnInit {
  @Input() invoice: Invoice;
  @Input() chamberId: string;
  @Input() receiptAvailable: boolean;

  loading: boolean;
  downloadUrl: string;

  loadingReceipt: boolean;
  downloadUrlReceipt: string;

  constructor(private invoiceService: InvoiceService, private ref: ChangeDetectorRef) { }

  ngOnInit() {
    this.loading = true;
    this.loadingReceipt = true;

    this.invoiceService.getInvoicePDF(this.invoice.InvoiceId, this.chamberId)
    .then((downloadLink: string) => {
      this.downloadUrl = downloadLink;
      this.loading = false;
      this.ref.detectChanges();
    });

    if (this.receiptAvailable || (this.invoice && this.invoice.IsDonation)) {
      this.invoiceService.getReceiptPDF(this.invoice.InvoiceId, this.chamberId)
      .then((downloadLink: string) => {
        this.downloadUrlReceipt = downloadLink;
        this.loadingReceipt = false;
        this.ref.detectChanges();
      });
    }
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/payment/dowload-invoice/dowload-invoice.component.ts